module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2017_06.fd11151b.jpg";